import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/search.svg'


const _withScopeId = n => (_pushScopeId("data-v-2dd2ace6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "col-md-8 search-container position-relative" }
const _hoisted_3 = ["placeholder", "maxlength"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "d-flex justify-content-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "d-flex justify-content-center"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "d-flex justify-content-center"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]

import { Tab } from '@/components/tabs/index.vue'
import TabPanel from '@/components/tabs/panel/TabPanel.vue'
import Tabs from '@/components/tabs/index.vue'
import All from './components/All.vue'
import NoGroup from './components/NoGroup.vue'
import { translate } from '@/languages/i18n'
import CreateGroupModal from '@/views/user/groups/components/CreateGroup.vue'
import { pick, isEqual } from 'lodash'
import { MAX_LENGTH_CONTENT_SEARCH } from '@/constants/number'
import { watch, ref, computed, onMounted, onUnmounted } from 'vue'
import { useRoute, onBeforeRouteLeave } from 'vue-router'
import { useStore } from 'vuex'
import { GROUPS_STORE } from '@/store/constants'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const page = ref<number>(1)

const route = useRoute()
const searchValue = ref<string>('')
const listGroups = computed(() => store.getters[GROUPS_STORE.GETTERS.LIST_GROUPS_LOAD_MORE])
const lastGroup = ref<HTMLElement>()
const observer = ref()
// 2022/09/30 CW-Phuong Fix for UAT Phase2#4473: SN10 (Ph2-R20220930)
const paramGetGroup = ref()

const getListGroups = (page: number, change) => {
  if (!route?.params?.id) return
  // 2022/09/30 CW-Phuong Fix for UAT Phase2#4473: SN10 (Ph2-R20220930)
  paramGetGroup.value = {
    change,
    id: route.params?.id,
    params: { group_type: route.query?.tab || '3', ...(page && { page }), keyword: searchValue.value, published: true },
  }
  store.dispatch(GROUPS_STORE.ACTIONS.SET_LIST_GROUPS_LOAD_MORE, paramGetGroup.value)
}

onMounted(() => {
  observer.value = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      if (page.value === listGroups.value.total_pages) return
      if (listGroups?.value?.listGroupsLoadMore?.length < 10) return
      page.value++
      getListGroups(page.value)
    }
  })

  if (lastGroup.value) {
    observer?.value?.observe(lastGroup.value)
  }
})

onMounted(() => {
  getListGroups(page.value, true)
})

watch(
  () => lastGroup.value,
  () => {
    if (lastGroup.value) {
      observer?.value?.observe(lastGroup.value)
    }
  }
)
watch(
  () => route.query,
  (newVal, oldVal) => {
    const tempOld = pick(oldVal, 'tab')
    const tempNewPr = pick(newVal, 'tab')
    if (newVal && !isEqual(tempOld, tempNewPr)) {
      page.value = 1
      if (route?.query?.tab) getListGroups(page.value, true)
    }
  },
  { deep: true }
)

const search = () => {
  store.dispatch(GROUPS_STORE.ACTIONS.SET_LIST_GROUPS_LOAD_MORE, {
    change: true,
    id: route.params?.id,
    params: { group_type: route.query?.tab || '3', keyword: searchValue.value, published: true },
  })
}

onBeforeRouteLeave(() => {
  store.dispatch(GROUPS_STORE.ACTIONS.REMOVE_LIST_GROUPS)
})

onUnmounted(() => {
  observer.value?.disconnect()
})
const tabs: Array<Tab> = [
  {
    title: translate('all'),
    alias: '3',
  },
  {
    title: translate('participatingGroups'),
    alias: '2',
  },
  {
    title: translate('manageGroup'),
    alias: '1',
  },
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CreateGroupModal),
    _createVNode(Tabs, {
      tabs: tabs,
      "default-alias": 'all',
      class: "mb-4"
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          class: "row justify-content-center",
          onSubmit: _withModifiers(search, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: _unref(translate)('search'),
              maxlength: _unref(MAX_LENGTH_CONTENT_SEARCH),
              class: "form-control w-100 shadow position-absolute pe-5",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event))
            }, null, 8, _hoisted_3), [
              [_vModelText, searchValue.value]
            ]),
            _createElementVNode("img", {
              src: _imports_0,
              alt: "search icon",
              class: "position-absolute d-flex justify-content-center align-items-center cursor-pointer",
              onClick: search
            })
          ])
        ], 40, _hoisted_1),
        _createVNode(TabPanel, {
          alias: '3',
          keyName: 3
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(All, { paramGetGroup: paramGetGroup.value }, null, 8, ["paramGetGroup"]),
              (_unref(listGroups)?.listGroupsLoadMore?.length > 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    ref: (_value, _refs) => {
                      _refs['lastGroup'] = _value
                      lastGroup.value = _value
                    }
                  }, null, 512))
                : _createCommentVNode("", true)
            ]),
            (_unref(listGroups)?.listGroupsLoadMore?.length === 0 && !_unref(listGroups)?.loadingGroups)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(NoGroup)
                ]))
              : _createCommentVNode("", true),
            (_unref(listGroups)?.loadingGroups)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(TabPanel, {
          alias: '2',
          keyName: 2
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(All, { paramGetGroup: paramGetGroup.value }, null, 8, ["paramGetGroup"]),
              (_unref(listGroups)?.listGroupsLoadMore?.length > 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    ref: (_value, _refs) => {
                      _refs['lastGroup'] = _value
                      lastGroup.value = _value
                    }
                  }, null, 512))
                : _createCommentVNode("", true)
            ]),
            (_unref(listGroups)?.listGroupsLoadMore?.length === 0 && !_unref(listGroups)?.loadingGroups)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(NoGroup)
                ]))
              : _createCommentVNode("", true),
            (_unref(listGroups)?.loadingGroups)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(TabPanel, {
          alias: '1',
          keyName: 1
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(All, { paramGetGroup: paramGetGroup.value }, null, 8, ["paramGetGroup"]),
              (_unref(listGroups)?.listGroupsLoadMore?.length > 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    ref: (_value, _refs) => {
                      _refs['lastGroup'] = _value
                      lastGroup.value = _value
                    }
                  }, null, 512))
                : _createCommentVNode("", true)
            ]),
            (_unref(listGroups)?.listGroupsLoadMore?.length === 0 && !_unref(listGroups)?.loadingGroups)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(NoGroup)
                ]))
              : _createCommentVNode("", true),
            (_unref(listGroups)?.loadingGroups)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})